import { useEffect, useRef } from 'react';

/**
 * Custom hook to detect the first render.
 * It will return `true` on the first render and `false` on subsequent renders.
 */
const useFirstRender = () => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    }
  }, []);
  return isFirstRender.current;
};

export default useFirstRender;
